export interface ApiCallResultModel {
  code: number;
  message: string;
}

export interface QuestionnaireInputResponseModel {
  fieldId: number;
  valueId: number;
  text: string;
}

export interface EventSeriesModel {
  isEventSeries: boolean;
  eventSeriesId: number;
}

export interface ZipCodeCities {
  cities: string[];
  zipCode: string;
  countryCode: string;
  formPath: string;
  isZipCodeInvalid: boolean;
  zipCodeHasValidation: boolean;
}

export enum TextOrDropdownInputTypes {
  Title = 'title',
  Function = 'function',
  Department = 'department',
  OccupationalGroup = 'occupationalGroup'
}

export interface BrowserSession {
  sessionId: string;
  active: boolean;
  created: Date;
  appVersion: string;
}

export type Hash = string;

export const enum HashStatus {
  NonExistent = 'nonExistent',
  Ok = 'ok',
  Invalid = 'invalid',
  Expired = 'expired',
  Waiting = 'waiting'
}

export const enum HashRequestType {
  NotSet = 'notSet',
  UserResetPassword = 'userResetPassword',
  PersonTicketClaim = 'personTicketClaim',
  ChangePasswordRequest = 'changePasswordRequest',
  ChangeEmailRequest = 'changeEmailRequest',
  EmailVerify = 'emailVerify',
  TicketPayment = 'ticketPayment',
  ConfirmNewsletterRequest = 'confirmNewsletterRequest'
}

export interface HashValidityStatusResponse {
  status: HashStatus;
  type: HashRequestType;
}

export type CountryListResponse = CountryResponse[];

export interface CountryResponse {
  id: number;
  code: string;
  shortCode: string;
  culture: unknown;
  nativeName: string;
  englishName: string;
  germanName: string;
}
